import React from 'react';
import { Spinner } from 'react-bootstrap';

interface loaderProps {
  show?: boolean;
  customHeight?: string;
}
const Loader = (props: loaderProps) => {
  const { show } = props;
  //#region External Hooks
  //#endregion
  return (
    <div
      className={`${show ? 'd-flex' : 'd-none'} flex-wrap`}
      style={{ height: props?.customHeight || '85vh' }}
    >
      <div className='col-md-12 d-flex flex-flow flex-column justify-content-center align-items-center'>
        <Spinner
          animation='grow'
          style={{ color: 'var(--app-border)' }}
        />
        <h3
          className='font-bold mt-3'
          style={{ color: 'var(--app-border)' }}
        >
          Loading...
        </h3>
      </div>
    </div>
  );
};

export default Loader;
